<template>
  <div id="app">
    
    <router-view/>
    
    <div id="goTop">
      <div class="goTop flex" v-show="goTopShow" @click="goTop"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      scrollTop: '',
      goTopShow:false,
      isPc: false
    }
  },
  beforeMount(){
    this.isPc = this.equipment()=='pc'?true:false
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll () {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if(this.scrollTop>500){
          　this.goTopShow=true
        } else {
           this.goTopShow=false
        }
    },
    goTop(){
        let timer=null,_that=this;
        cancelAnimationFrame(timer)
        timer=requestAnimationFrame(function fn(){
          if(_that.scrollTop>0){
              _that.scrollTop-=500;
              document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
              timer=requestAnimationFrame(fn)
          }else {
            　cancelAnimationFrame(timer);
            　_that.goTopShow=false;
          }
        })
    }
  },
  destroyed(){
      window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.goTop{
    position: fixed;
    right: .3rem;
    bottom: .4rem;
    width: 0;
    height: 0;
    border-bottom: 1rem solid #000;
    border-left: .2rem solid transparent;
    border-right: .2rem solid transparent;
    border-top: 0;
    font-size: .43rem;
    font-weight: 400;
    font-family: Girott;
    color: #fff;
    cursor: pointer;
    text-shadow: #1f1f1f 1px 0 0, #1f1f1f 0 1px 0, #1f1f1f -1px 0 0, #1f1f1f 0 -1px 0;
}
.goTop font{
  margin-left: .15rem;
}
</style>
<style>
@font-face {
    font-family: Girott ;
    src: url("http://oss.dabeiyuzhou.com/font/NotoSansHans-Bold.ttf");
    /* src: url("http://oss.dabeiyuzhou.com/font/Girott.otf"); */
}
@font-face {
    font-family: STSongti-SC;
    src: url("http://oss.dabeiyuzhou.com/font/hw.ttf");
}
@font-face {
    font-family: STSongti-SC-Bold;
    src: url("http://oss.dabeiyuzhou.com/font/hw-blod.ttf");
}
@font-face {
    font-family: NotoSansHans;
    src: url("http://oss.dabeiyuzhou.com/font/NotoSansHans-Medium.ttf");
}
.pc{
    display: flex;
    margin: 0 auto;
  }
  .mobile{
    display: flex;
  }
/* pc */
/* @media screen and (min-width: 1025px) {
  .pc{
    display: flex;
    margin: 0 auto;
  }
  .mobile{
    display: flex;
  }
  .tablet{
    display: none;
  } 
} */
/* 平板 */
/* @media screen and (min-width: 768px) and (max-width:1024px){
  .pc{
    display: none;
  }
  .mobile{
    display: none;
  }
  .tablet{
    display: flex;
  }
} */
/* 手机 */
/* @media screen and (max-width: 1024px) {
  .pc{
    display: none;
  }
  .mobile{
    display: flex;
  }
  .tablet{
    display: none;
  } 
} */
#app{
  min-height: 100vh;
  background: #fff;
}
*{margin: 0;padding: 0;}
.flex {
  display: flex;
}
.fw-w {
  flex-wrap: wrap;
}
.fw-nw{
  flex-wrap: nowrap;
}
.fd-r{
  flex-direction: row;
}
.fd-c {
  flex-direction: column;
}
.fd-rr {
  flex-direction: row-reverse;
}
.ai-c {
  align-items: center;
}
.ai-fd {
  align-items: flex-end;
}
.ai-fs {
  align-items: flex-start;
}
.ai-bl {
  align-items: baseline;
}
.jc-c {
  justify-content: center;
}
.jc-sb {
  justify-content: space-between;
}
.jc-sa {
  justify-content: space-around;
}
.jc-fd {
  justify-content: flex-end;
}
.jc-fs {
  justify-content: flex-start;
}
:-moz-placeholder {
  color: rgba(182, 182, 182, 1);
  opacity: 1;
}
/* Mozilla Firefox 4 to 18 *
::-moz-placeholder { color: #000;opacity:1; }支持 /* Mozilla Firefox 19+ */ 
input:-ms-input-placeholder {
  color: rgba(182, 182, 182, 1);
  opacity: 1;
}
input::-webkit-input-placeholder {
  color: rgba(182, 182, 182, 1);
  opacity: 1;
}
input::-moz-input-placeholder {
  color: rgba(182, 182, 182, 1);
  opacity: 1;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
/* 火狐 */
input[type="number"] {
  -moz-appearance: textfield;
}
input,textarea{
  outline:none;
}
div::selection{ background:none }
div::-moz-selection    { background:none }
div::-webkit-selection { background:none}
.cp{
  cursor: pointer;
}
@keyframes blink{
  0%{color: #000;}
  100%{color: #fff;} 
}
.flash:hover{
  cursor: pointer;
  animation: blink 0.1s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/App.vue